import React, { useState, useEffect } from 'react';
import { parseProps, componentIdGenerator } from './@uteis';
import BRTabs from '../../assets/dsgov/js/components/tabs';
import '../../assets/dsgov/css/components/tabs.css';

const Tabs = (_props) => {
  const [componentId] = useState(
    `tabs${componentIdGenerator()}`,
  );
  const props = parseProps(_props);

  useEffect(() => {
    new BRTabs('br-tabs', window.document.querySelector(`.${componentId}`));
  });

  const classes = `br-tabs ${componentId} ${props.classes}`;

  const listNav = [];
  const listTab = [];

  const listTabs = props.tabs;
  for (let index = 0; index < listTabs.length; index++) {
    const actived = props.activedTab === index ? 'is-active' : null;
    listNav.push(
      <li className={`tab-item ${actived}`} key={index}>
        <button type="button" data-panel={`panel-${index}`}>
          <span className="name">{listTabs[index].title}</span>
        </button>
      </li>,
    );
    listTab.push(
      <div className={`tab-panel ${actived}`} id={`panel-${index}`} key={index}>
        {listTabs[index].content}
      </div>,
    );
  }

  return (
    <div className={classes}>
      <nav className="tab-nav">
        <ul>{listNav}</ul>
      </nav>
      <div className={`tab-content ${props.contentStyle}`}>
        {listTab}
      </div>
    </div>
  );
};

export default Tabs;
